import * as React from 'react';

import { cn } from '../../utils';
import { EyeIcon, EyeOffIcon } from 'lucide-react';
import { ReactNode } from 'react';

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  startAdornment?: ReactNode;
  endAdornment?: ReactNode;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, startAdornment, endAdornment, ...props }, ref) => {
    const [isInputFocused, setIsInputFocused] = React.useState(false);
    const [hideCharacters, setHideCharacters] = React.useState(
      type === 'password'
    );

    const hasAdornment = Boolean(startAdornment) || Boolean(endAdornment);
    const isTypePassword = type === 'password';

    return (
      // eslint-disable-next-line react/jsx-no-useless-fragment
      <>
        {hasAdornment || isTypePassword ? (
          <div
            className={`flex items-center gap-0 pr-3 h-10 rounded-md border bg-background data-[disabled=true]:cursor-not-allowed data-[disabled=true]:opacity-50 ${
              isInputFocused ? 'border-ring' : 'border-input'
            } ${className}`}
            data-disabled={props.disabled}
          >
            {startAdornment && (
              <div className={cn('text-muted-foreground text-nowrap pl-3')}>
                {startAdornment}
              </div>
            )}
            <input
              onFocusCapture={() => {
                setIsInputFocused(true);
              }}
              onBlurCapture={() => setIsInputFocused(false)}
              type={hideCharacters ? type : 'text'}
              className={cn(
                'flex h-full w-full rounded-md bg-background rounded-r-none py-2 text-sm file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground shadow-none outline-none border-none focus-visible:outline-none focus-visible:border-none focus-visible:shadow-none focus:border-ring',
                startAdornment ? 'pl-1' : 'pl-3'
              )}
              ref={ref}
              {...props}
            />
            {(endAdornment || isTypePassword) && (
              <div className={cn('text-muted-foreground')}>
                {isTypePassword ? (
                  hideCharacters ? (
                    <EyeIcon
                      onClick={() => setHideCharacters(false)}
                      className="cursor-pointer"
                    />
                  ) : (
                    <EyeOffIcon
                      onClick={() => setHideCharacters(true)}
                      className="cursor-pointer"
                    />
                  )
                ) : (
                  endAdornment
                )}
              </div>
            )}
          </div>
        ) : (
          <input
            type={type}
            className={cn(
              'flex h-10 w-full rounded-md border border-input bg-background autofill:bg-background px-4 py-2 text-sm file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 focus:border-ring',
              className
            )}
            ref={ref}
            {...props}
          />
        )}
      </>
    );
  }
);

Input.displayName = 'Input';

export { Input };
